<div class="main-container-custom" *ngIf="isNetSkope" #customDropDownArea>
  <div class="custom-drop-container"
    [@colorOpener]="{value: mode, params: {closed: closedColor , opened:openedColor}}"
    [ngStyle]="{width:widthArea}">
    <div class="arrow-opener" role="button" tabindex="0" aria-label="Toggle dropdown"
      [attr.aria-expanded]="isDropDownOpen" [attr.aria-controls]="dropdownListId"
      (click)="openDrop(isDropDownOpen = !isDropDownOpen)"
      (keydown.enter)="activateNetSkopeToggle($event)"
      (keydown.space)="activateNetSkopeToggle($event)"
      (keydown.escape)="closeDropDownFromKeyboard($event)">
      <div class="arrow-icon-custom" [ngClass]="{'expandClass-custom':isDropDownOpen}" cygovSvgIcon
        [svgName]="'arrow-right-type3'">
      </div>
    </div>
    <div class="selected-option-custom lato-14-n-vw"><span>{{selectedItem | replace:'_':' ' |
        titlecase }}</span></div>
  </div>
  <div class="option-list-custom" role="listbox" *ngIf="isDropDownOpen" [id]="dropdownListId"
    [@heightUpdate]="isDropDownOpen ? 'appear':'void'">
    <ng-container *ngFor="let item of itemList; let idx = index">
      <div *ngIf="idx" class="option-item-custom lato-14-n-vw" role="option" tabindex="0"
        [attr.aria-selected]="item === selectedItem" (click)="optionSelected(item,idx)"
        (keydown.enter)="activateNetSkopeItem($event, item, idx)"
        (keydown.space)="activateNetSkopeItem($event, item, idx)">
        <span>{{item | replace:'_':' ' | titlecase}}</span>
      </div>
    </ng-container>
  </div>
</div>

<div *ngIf="!isNetSkope" class="custom-dropdown">
  <div class="dropdown" [ngStyle]="{'width' : widthArea}">
    <div class="title lato-16-n-vw" role="button" tabindex="0" [attr.aria-label]="title"
      [attr.aria-expanded]="isDropDownOpen" [attr.aria-controls]="dropdownListId"
      [ngStyle]="{'background-color' : isDropDownOpen ? opened : closed}" (click)="toggleDropDown()"
      (keydown.enter)="activateToggle($event)" (keydown.space)="activateToggle($event)"
      (keydown.escape)="closeDropDownFromKeyboard($event)">
      <div class="title-text">
        <div *ngIf="!selectedItems.length" class="lbl-text">{{ title }}</div>
        <div *ngIf="isDropDownOpen && selectedItems.length" class="selected-lbl-text">{{
          singleSelect ?
          selectedItems[0][bindLabel] : title }}</div>
        <ng-container *ngIf="!isDropDownOpen && isGlobalControl && selectedItems.length">
          <div class="wrapper">
            <span class="text">{{selectedItems[0][bindLabel].slice(0, 30)}}</span>
            @if(selectedItems.length> 1 || selectedItems[0][bindLabel].length > 30) {
            <span>...</span>
            }
          </div>
        </ng-container>
        <ng-container *ngIf="!isGlobalControl &&!isDropDownOpen && selectedItems.length">
          <ng-container *ngFor="let item of selectedItems; let i = index; let last = last">
            <div class="wrapper">
              <span class="text">{{item[bindLabel]}}</span>
              <span *ngIf="!showCross && !last">,&nbsp;&nbsp; </span>
              <div *ngIf="showCross" class="close-row" (click)="removeItem($event, item, i)"
                role="button"
                [attr.tabindex]="disabledItemIds && disabledItemIds.includes(item.id) ? -1 : 0"
                [attr.aria-disabled]="disabledItemIds && disabledItemIds.includes(item.id)"
                [attr.aria-label]="'Remove ' + item[bindLabel]"
                (keydown.enter)="removeItemFromKeyboard($event, item, i)"
                (keydown.space)="removeItemFromKeyboard($event, item, i)">
                <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'">
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
      <div *ngIf="showMore" class="more-button">More...</div>
      <div class="arrow-icon-right" [ngClass]="{'rotate-arrow-down':isDropDownOpen}" cygovSvgIcon
        [svgName]="'arrow-right-type3'">
      </div>
    </div>
    <div class="expanded-dropdown" role="listbox" *ngIf="isDropDownOpen" [id]="dropdownListId"
      [ngStyle]="{'width' : widthArea, 'background-color': itemsColor}">
      <div *ngIf="showSearch" class="search-wrapper">
        <div class="search-icon" cygovSvgIcon [svgName]="searchIconSvgName"></div>
        <input type="text" class="form-control search" aria-label="Search" placeholder="Search"
          [(ngModel)]="queryTextfromInput" name="search" spellcheck="true" (keyup)="searchList()"
          (keydown.escape)="closeDropDownFromKeyboard($event)" />
      </div>
      <div *ngIf="itemList && itemList.length" class="list-items-wrapper">
        <ng-container *ngFor="let item of itemList; let i = index;">
          <div class="item-row lato-14-l-vw" role="option"
            [attr.aria-selected]="item.selected"
            [attr.aria-disabled]="disabledItemIds && disabledItemIds.includes(item.id)"
            [attr.tabindex]="disabledItemIds && disabledItemIds.includes(item.id) ? -1 : 0"
            [class.disabled-item]="disabledItemIds && disabledItemIds.includes(item.id)"
            (keydown.enter)="activateItem($event, item)"
            (keydown.space)="activateItem($event, item)"
            (keydown.escape)="closeDropDownFromKeyboard($event)">
            <cygov-checkbox *ngIf="showCheckbox" class="access-checkbox" [id]="'item-'+i"
              [isChecked]="item.selected" [height]="12" [width]="12"
              (changed)="selectItem(item)"></cygov-checkbox>
            <span [ngStyle]="{color: item.selected ? selectedColor : null}"
              (click)="selectItem(item)">{{item[bindLabel]}}</span>
          </div>
          <div *ngIf="customSeprator" class="horizontal-seprator"></div>
        </ng-container>
      </div>
      <!-- a search that matches nothing gets the shared no-results panel; a genuinely empty list keeps its own text -->
      <div *ngIf="itemList && !itemList.length && queryTextfromInput" class="no-data-found-wrapper">
        <cygov-no-data-found (clearSearch)="clearSearch()"></cygov-no-data-found>
      </div>
      <ng-container *ngIf="itemList && !itemList.length && !queryTextfromInput">
        <span class="no-message">{{isSubEntitySelection? 'No Sub Entity' : 'No Industry' }}</span>
      </ng-container>
    </div>
  </div>
</div>